module.exports = __webpack_public_path__ + "static/media/inicioChatTransp.2889ebc5.png";